module.exports = __webpack_public_path__ + "img/home-bg-fore.bca5d9e0.png";